// @flow

import { I18n } from 'react-redux-i18n';
import { reduce } from '../../network/reduce';
import type { OfficePartial } from '../../types/OfficesType';
import type { MediaGallery } from '../../types/keepeekType';
import type { Filter } from '../../types/shoppingCenterType';

export type initialStateType = {
  +baseOfficeList: OfficePartial[],
  +isOfficeSelected: boolean,
  +officeList: OfficePartial[],
  +officesCitiesList: string[],
  +officesMedias: MediaGallery[],
  +filteredOfficeRequest: string,
  +officeAppliedFilters: Filter[],
}

export const officeAppliedFiltersInitial = [
  {
    label: I18n.t('filters.CITIES'),
    selected: [],
  },
];

const initialState: initialStateType = {
  baseOfficeList: [],
  officeList: [],
  officesCitiesList: [],
  isOfficeSelected: false,
  officesMedias: [],
  filteredOfficeRequest: '',
  officeAppliedFilters: officeAppliedFiltersInitial,
};

export const SAVE_OFFICES_LIST = 'SAVE_OFFICES_LIST';

export const FILTER_OFFICES_LIST = 'FILTER_OFFICES_LIST';

export const SAVE_OFFICES_CITIES_LIST = 'SAVE_OFFICES_CITIES_LIST';

export const FILTERED_OFFICE_REQUEST = 'FILTERED_OFFICE_REQUEST';

export const OFFICE_APPLIED_FILTERS = 'OFFICE_APPLIED_FILTERS';

export const SAVE_OFFICES_MEDIA = 'SAVE_OFFICES_MEDIA';

export const SET_OFFICES_SELECTED = 'SET_OFFICES_SELECTED';

const officesReducer = reduce(initialState, {
  [SAVE_OFFICES_LIST]: 'baseOfficeList',
  [SET_OFFICES_SELECTED]: 'isOfficeSelected',
  [FILTER_OFFICES_LIST]: 'officeList',
  [FILTERED_OFFICE_REQUEST]: 'filteredOfficeRequest',
  [OFFICE_APPLIED_FILTERS]: 'officeAppliedFilters',
  [SAVE_OFFICES_CITIES_LIST]: 'officesCitiesList',
  [SAVE_OFFICES_MEDIA]: 'officesMedias',
});

export default officesReducer;
